import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7327da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-dialog-content" }
const _hoisted_2 = { class: "product-panel" }
const _hoisted_3 = { class: "panel-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel-title" }, "选择产品", -1))
const _hoisted_5 = { class: "product-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "product-info" }
const _hoisted_9 = { class: "product-name" }
const _hoisted_10 = { class: "product-sub" }
const _hoisted_11 = { class: "product-side" }
const _hoisted_12 = {
  key: 0,
  class: "product-unavailable"
}
const _hoisted_13 = {
  key: 1,
  class: "product-count"
}
const _hoisted_14 = {
  key: 0,
  class: "product-empty"
}
const _hoisted_15 = { class: "scene-panel" }
const _hoisted_16 = {
  key: 0,
  class: "scene-empty-hint"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "请选择左侧产品", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-product-meta" }, " 选择产品后，右侧展示根据产品属性匹配的场景。 ", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "scene-toolbar"
}
const _hoisted_21 = { class: "scene-product-name" }
const _hoisted_22 = { class: "scene-product-meta" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scene-toolbar-tip" }, " 已基于当前产品信息为你推荐适用场景，请选择。 ", -1))
const _hoisted_24 = { class: "scene-table-wrap" }

import { ref, computed, reactive, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useDebounceFn } from '@vueuse/core';
import {
  BaseDialog,
  BaseButton,
  BaseToolTip,
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  XrkMessage,
  useTableColumn,
  useSelectColumn,
  BaseAffix
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import appStore from '@/store';
import { formatter } from '@/utils/';
import { getSceneProductList, getSceneSceneList } from '../data-source/apis';
import type {
  SceneManageProductItem,
  SceneManageProductBaseDTO,
  SceneManageSceneItem
} from '../data-source/types';

// ======================== Props & Emits ========================


export default /*#__PURE__*/_defineComponent({
  __name: 'scene-select-dialog',
  props: {
    remove: { type: Function, default() {
      /* auto-injected */
    } },
    products: {},
    industryName: { default: '' },
    industryId: { default: undefined },
    aspId: { default: undefined },
    platformId: { default: undefined },
    planId: { default: undefined }
  },
  emits: ["confirm"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

// ======================== 状态 ========================

/** 仅 IAS：工业角色（functionCode=1）显示「新增产品」入口 */
const router = useRouter();
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);
const isIndustry = computed(() => userInfo.value?.functionCode === 1);

/** 左侧全量产品（V2 product/page 返回 SceneManageProductBaseDTO，无 scenes） */
const allProducts = ref<SceneManageProductBaseDTO[]>([]);
/** 产品列表加载中 */
const productLoading = ref(false);
/** 勾选集合：productId → SceneManageProductItem（scenes 只存勾选的场景，与 SceneManageProductItem 结构一致） */
const checkedMap = reactive(
  new Map<string, SceneManageProductItem>()
) as unknown as Map<string, SceneManageProductItem>;
/** 场景加载中 */
const sceneLoading = ref(false);
/** 当前产品场景筛选 options（接口返回字符串数组；remoteMethod 假远程从这取，保证下拉响应） */
const sceneOptions = reactive({
  sceneNameOptions: [] as string[],
  medicalRepTagOptions: [] as string[],
  terminalChannelOptions: [] as string[],
  serviceObjectOptions: [] as string[]
});
/** 首次加载标记（搜索刷新不重新激活/拉场景） */
const initialized = ref(false);
/** 初始化激活：有已勾选产品时默认激活第一个已勾选产品，否则激活第一个产品 */
const activeProductId = ref<string>('');
/** 左侧产品本地搜索关键词 */
const productQuery = ref('');

/**
 * BaseAffix 固定偏移：左侧面板头部固定时距视口顶部的距离
 * 弹窗实际高度 = min(85vh, 650px)（xrk-components dialog 内置 max-height）
 * 实测：topGap 即为正确偏移，无需再加 dialog header 高度
 */
const affixOffset = computed(() => {
  const vh = window.innerHeight || 900;
  const dialogH = Math.min(vh * 0.85, 650);
  const topGap = Math.max((vh - dialogH) / 2, 0);
  return Math.round(topGap);
});

const xrkTableRef = ref<XrkTableRef>(null);

// ======================== 初始化 ========================

/** 加载左侧产品列表（V2 product/page：固定 pageSize=100 + productName 远程搜索）+ 用 props 勾选集合初始化默认勾选/赋值 */
const loadProducts = async () => {
  productLoading.value = true;
  try {
    const res = await getSceneProductList({
      industryId: props.industryId || undefined,
      productName: productQuery.value.trim() || undefined,
      pageNum: 1,
      pageSize: 100
    });
    allProducts.value = res?.data?.page?.list || [];
    // 用调用层传入的勾选集合做默认勾选（深拷贝隔离，取消不影响父组件）
    props.products.forEach(p => {
      checkedMap.set(p.productId, JSON.parse(JSON.stringify(p)));
    });
    // detail 的 available 优先于 product/page：把已配置产品的可用状态覆盖到左侧产品
    const detailAvailable = new Map(
      props.products.map(p => [p.productId, p.available])
    );
    allProducts.value.forEach(product => {
      const av = detailAvailable.get(product.productId);
      if (av !== undefined) product.available = av;
    });
    // 已勾选产品可能不在前 100 条内（产品多时）：合并进左侧列表；已勾选产品一律置顶展示
    const checkedIds = new Set(allProducts.value.map(p => p.productId));
    props.products.forEach(p => {
      if (!checkedIds.has(p.productId)) {
        allProducts.value.push({
          productId: p.productId,
          productName: p.productName || '',
          approvalNumber: p.approvalNumber || '',
          manufacturingEnterprise: p.manufacturingEnterprise || '',
          dosageForm: p.dosageForm || '',
          indication: p.indication || '',
          drugName: p.drugName || '',
          productCategory: p.productCategory || '',
          productAttribute: p.productAttribute || '',
          lifecycleStage: p.lifecycleStage || '',
          productSpec: p.productSpec || '',
          drugInstructions: p.drugInstructions || '',
          projectJustificationUrl: p.projectJustificationUrl || '',
          dictionariesName: (p as any).dictionariesName || '',
          departments: (p as any).departments || '',
          productType: p.productType,
          available: (p as any).available
        });
      }
    });
    // 已勾选产品置顶（勾选集合的产品排最前，其余按接口顺序）
    allProducts.value.sort((a, b) => {
      const aChecked = checkedMap.has(a.productId) ? 0 : 1;
      const bChecked = checkedMap.has(b.productId) ? 0 : 1;
      return aChecked - bChecked;
    });
    // 首次加载：默认激活第一个已勾选产品（否则第一个产品）+ 加载场景；
    // 搜索刷新：激活产品不变（已勾选产品置顶始终可见），场景数据无需重拉
    if (!initialized.value) {
      initialized.value = true;
      const firstChecked = [...checkedMap.keys()][0];
      activeProductId.value =
        firstChecked || allProducts.value[0]?.productId || '';
      if (activeProductId.value) {
        xrkTableRef.value?.initList?.();
      }
    }
  } catch (error) {
    console.error('加载产品列表失败:', error);
    XrkMessage.error('获取产品列表失败');
  } finally {
    productLoading.value = false;
  }
};

/** 激活产品时加载场景：由 XrkTable getListAjax 远程分页承担（每次翻页/搜索调接口） */

onMounted(() => {
  loadProducts();
});

/** 产品搜索：输入防抖 300ms 远程搜索（V2 product/page productName 参数，useDebounceFn） */
const debouncedLoadProducts = useDebounceFn(loadProducts, 300);

watch(productQuery, () => {
  debouncedLoadProducts();
});

// ======================== 计算属性 ========================

const activeProduct = computed(
  () =>
    allProducts.value.find(p => p.productId === activeProductId.value) ||
    // 搜索后激活产品可能不在结果列表（非勾选产品）：用勾选集合兜底，避免空态误判
    checkedMap.get(activeProductId.value) ||
    null
);

/** 左侧产品列表（接口已按 productName 远程过滤，直接展示） */
const filteredProducts = computed(() => allProducts.value);

// ======================== 搜索配置 ========================

const paginationConfig = {
  paginationPageSize: 15
};

/** sceneOptions 字段与下拉 prop 映射 */
const SCENE_OPTIONS_KEY: Record<string, string> = {
  sceneName: 'sceneNameOptions',
  medicalRepTag: 'medicalRepTagOptions',
  terminalChannelText: 'terminalChannelOptions',
  serviceObjectText: 'serviceObjectOptions'
};

/**
 * 场景筛选下拉假远程数据源：不调接口，从 sceneOptions（getListAjax 接口返回时更新）取选项，
 * 按接口数据结构 { data: { list } } 返回，解决 options prop 配置后不响应的问题（remote 每次执行取最新数据）
 */
const buildSceneRemote = (field: string) => (val?: string) => {
  const key = SCENE_OPTIONS_KEY[field];
  // 展示截断：默认只返回前 100 条（全量 options 上千条时下拉渲染卡顿）；
  // 搜索全量：关键词从全量数组过滤（BaseSelect 内部还会按 label 二次过滤，双保险）
  const list = ((sceneOptions as any)[key] || [])
    .filter((v: string) => v !== '全部')
    .filter((v: string) => !val || v.includes(val))
    .slice(0, 100)
    .map((v: string) => ({ [field]: v }));
  return Promise.resolve({ data: { list } });
};

const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    // 切换搜索/翻页时保留已勾选行（XrkTable 默认搜索会清空勾选）
    reserveSelection: true,
    searchColumns: [
      useSelectColumn({
        prop: 'sceneName',
        label: '场景名称',
        config: {
          placeholder: '全部',
          clearable: true,
          filterUseRemote: true,
          init: true,
          labelKey: 'sceneName',
          valueKey: 'sceneName',
          remoteMethod: buildSceneRemote('sceneName')
        }
      }),
      useSelectColumn({
        prop: 'medicalRepTag',
        label: '备案类型',
        config: {
          placeholder: '全部',
          clearable: true,
          filterUseRemote: true,
          init: true,
          labelKey: 'medicalRepTag',
          valueKey: 'medicalRepTag',
          remoteMethod: buildSceneRemote('medicalRepTag')
        }
      }),
      useSelectColumn({
        prop: 'terminalChannelText',
        label: '终端渠道',
        config: {
          placeholder: '全部',
          clearable: true,
          filterUseRemote: true,
          init: true,
          labelKey: 'terminalChannelText',
          valueKey: 'terminalChannelText',
          remoteMethod: buildSceneRemote('terminalChannelText')
        }
      }),
      useSelectColumn({
        prop: 'serviceObjectText',
        label: '适用服务对象',
        config: {
          placeholder: '全部',
          clearable: true,
          filterUseRemote: true,
          init: true,
          labelKey: 'serviceObjectText',
          valueKey: 'serviceObjectText',
          remoteMethod: buildSceneRemote('serviceObjectText')
        }
      })
    ],
    otherComponents: [
      {
        render: () => (
          <span class="scene-batch-btns">
            <BaseButton onClick={() => onSelectAll(true)}>全选</BaseButton>
            <BaseButton onClick={() => onSelectAll(false)}>清空</BaseButton>
          </span>
        )
      }
    ]
  };
});

// ======================== 表格配置 ========================

const formatPrice = (price?: number) => {
  if (price == null) return '--';
  // 金额已在 translators 层分→元（scenePageToYuan），直接展示
  return String(price);
};

const tableConfig = computed<XrkTableProps['tableConfig']>(() => ({
  baseConfig: {
    rowKey: '_id',
    // 空态：未选产品时提示选药，已选产品无匹配场景时提示无结果（需求 HTML：colspan 空行文案）
    emptyText: activeProduct.value
      ? '暂无符合条件的场景'
      : '请先选择产品，系统将根据产品属性匹配可选场景'
  },
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: '_id',
      width: 90,
      fixed: 'left',
      // 勾选/取消场景后同步勾选集合（产品自动勾选 UI + 已选计数实时更新）
      selectionAddAfter: (row: any) => {
        syncSceneChecked(row, true);
      },
      selectionRemoveAfter: (row: any) => {
        syncSceneChecked(row, false);
      },
      // 当页全选/取消全选：XrkTable 内部只更新 store 不触发 After 钩子（左侧已选 N 不同步），
      // 手动拿当页数据同步 checkedMap 后再执行默认逐行勾选/取消逻辑
      selectionAllBefore: (done: Function) => {
        const pageRows = getPageRows();
        const rows = xrkTableRef.value?.getSelectionRows?.() || [];
        // 方向判断与 XrkTable 内部 checkboxAllChecked 一致：当页全部已勾 → 本次点击为取消
        const allChecked =
          pageRows.length > 0 &&
          pageRows.every((r: any) => rows.some((s: any) => s._id === r._id));
        pageRows.forEach((r: any) => syncSceneChecked(r, !allChecked));
        done();
      },
      // 表头「已选 N 项」自定义：只显示当前页已勾选数（内置默认 = 全局 selectionIds 总数，跨页懒加载回显导致翻页跳变）
      renderHeaderSelectionLabel: () => {
        const rows = xrkTableRef.value?.getSelectionRows?.() || [];
        const ids = new Set(rows.map((r: any) => r._id));
        const count = getPageRows().filter((r: any) => ids.has(r._id)).length;
        return count > 0 ? `已选 ${count} 项` : '';
      }
    }),
    useTableColumn({
      label: '推荐场景',
      prop: 'sceneName',
      width: 280,
      formatter: ({ cellValue }: { cellValue: string }) => cellValue || '--'
    }),
    useTableColumn({
      label: '是否备案建议',
      prop: 'medicalRepTag',
      width: 120,
      formatter: ({ cellValue }: { cellValue: string }) =>
        formatter.defaultFormat(cellValue)
    }),
    useTableColumn({
      label: '终端渠道/服务对象',
      prop: 'terminalChannelText',
      minWidth: 160,
      render: ({ row }: { row: SceneManageSceneItem }) => (
        <div class="channel-object-cell">
          <div>终端渠道：{row.terminalChannelText || '-'}</div>
          <div class="channel-object-sub">
            服务对象：{row.serviceObjectText || '-'}
          </div>
        </div>
      )
    }),
    useTableColumn({
      label: '服务简介',
      prop: 'projectIntroduction',
      minWidth: 200,
      render: ({ row }: { row: SceneManageSceneItem }) => (
        <div class="intro-cell">
          <span class="intro-text">{row.projectIntroduction || '--'}</span>
          {row.projectIntroduction && (
            <BaseToolTip
              content={row.projectIntroduction}
              placement="top"
            ></BaseToolTip>
          )}
        </div>
      )
    }),
    useTableColumn({
      label: '推荐理由',
      prop: 'sceneObjective',
      minWidth: 180,
      formatter: ({ cellValue }: { cellValue: string }) => cellValue || '-'
    }),
    useTableColumn({
      label: '输出成果',
      prop: 'coreKpi',
      minWidth: 160,
      formatter: ({ cellValue }: { cellValue: string }) => cellValue || '-'
    }),
    useTableColumn({
      label: '历史执行',
      prop: 'executeProjectCount',
      width: 170,
      render: ({ row }: { row: SceneManageSceneItem }) => {
        const count = row.executeProjectCount || 0;
        if (count > 0) {
          return (
            <div class="history-cell">
              <span class="history-badge">已执行 {count} 次</span>
              <span class="history-settle">
                累计结算 ￥{formatPrice(row.cumulativeSettlementAmount)}
              </span>
            </div>
          );
        }
        return <span class="history-empty">—</span>;
      }
    }),
    useTableColumn({
      label: '平台价格区间',
      prop: 'platformPriceLower',
      width: 150,
      render: ({ row }: { row: SceneManageSceneItem }) => (
        <span>
          {formatPrice(row.platformPriceLower)} ~{' '}
          {formatPrice(row.platformPriceUpper)} 元
        </span>
      )
    })
  ]
}));

// ======================== 表格数据源（远程分页） ========================

const getListAjax = async (params?: Record<string, any>) => {
  const {
    sceneName,
    medicalRepTag,
    terminalChannelText,
    serviceObjectText,
    pageNum = 1,
    pageSize = 15
  } = params || {};

  // 未激活产品：空数据（未选产品提示由模板 scene-empty-hint 承担）
  if (!activeProductId.value) {
    return { data: { list: [], total: 0 } };
  }

  // 当前激活产品：把产品的三个属性传给场景接口（匹配覆盖值，无值传 undefined 不序列化）
  const activeProd = allProducts.value.find(
    p => p.productId === activeProductId.value
  );
  const res = await getSceneSceneList({
    productId: activeProductId.value,
    planId: props.planId || undefined,
    industryId: props.industryId || undefined,
    aspId: props.aspId || undefined,
    sceneName: sceneName || undefined,
    terminalChannelText: terminalChannelText || undefined,
    serviceObjectText: serviceObjectText || undefined,
    medicalRepTag: medicalRepTag || undefined,
    productCategory: activeProd?.productCategory || undefined,
    productAttribute: activeProd?.productAttribute || undefined,
    lifecycleStage: activeProd?.lifecycleStage || undefined,
    pageNum,
    pageSize
  });
  const data = res?.data;
  // 4 个搜索项 options：接口返回的筛选结果选项（remoteMethod 假远程从这里取）
  sceneOptions.sceneNameOptions = data?.sceneNameOptions || [];
  sceneOptions.medicalRepTagOptions = data?.medicalRepTagOptions || [];
  sceneOptions.terminalChannelOptions = data?.terminalChannelOptions || [];
  sceneOptions.serviceObjectOptions = data?.serviceObjectOptions || [];

  // 勾选集合合并：跨页勾选回显（checkedMap 场景命中标记 selected + 默认赋值字段覆盖；_id 唯一辨识）
  const checkedProduct = checkedMap.get(activeProductId.value);
  const list = (data?.scenePage?.list || []).map(scene => {
    // _id = 产品id_场景id（接口对齐返回，前端兜底构造）
    const _id = scene._id || `${activeProductId.value}_${scene.sceneId}`;
    const checked = (checkedProduct?.scenes || []).find(
      s => s.sceneId === scene.sceneId
    );
    const row = checked
      ? { ...scene, _id, ...checked, selected: true }
      : { ...scene, _id, selected: false };
    // 已勾选场景回显到 XrkTable selectionIds（跨页保留，重复 add 去重无害）
    if (row.selected) {
      xrkTableRef.value?.addSelectionRow?.(_id, row);
    }
    return row;
  });

  return { data: { list, total: data?.scenePage?.total || 0 } };
};

// ======================== 方法 ========================

/** 仅 IAS 工业角色：新增产品（关弹窗 → 跳产品库） */
const onAddProduct = async () => {
  try {
    await router.push({ name: 'product-mgmt-library' });
    props.remove();
  } catch (e) {
    XrkMessage.error('无产品库菜单权限');
  }
};

/** 当前页行数据（getTableData 返回 ref 需解包，use-table.tsx pageAllData = ref([])） */
const getPageRows = (): any[] => {
  const raw = xrkTableRef.value?.getTableData?.();
  return ((Array.isArray(raw) ? raw : raw?.value) ?? []) as any[];
};

/** 产品下已选场景数（左侧「已选 N」：checkedMap 响应式，实时准确不依赖激活/加载） */
const getProductSceneCount = (productId: string) => {
  const product = checkedMap.get(productId);
  if (!product) return 0;
  return (product.scenes || []).length;
};

/** 激活产品（勾选/点击均触发）：切换激活 + 清空筛选条件（场景数据由 getListAjax 远程分页拉取；各产品勾选独立保留，_id 前缀隔离） */
const onSwitchProduct = (productId: string) => {
  if (activeProductId.value === productId) return;
  activeProductId.value = productId;
  // 清空 store 勾选：表头「已选 N 项」= 全局 selectionIds 总数，跨产品残留会污染文案；
  // getListAjax 按 checkedMap 回显当前产品已勾选行，勾选数据不丢
  xrkTableRef.value?.clearSelectionRows?.();
  // 清空 store 勾选：表头「已选 N 项」= 全局 selectionIds 总数，跨产品残留会污染文案；
  // getListAjax 按 checkedMap 回显当前产品已勾选行，勾选数据不丢
  xrkTableRef.value?.clearSelectionRows?.();
  xrkTableRef.value?.clearSearchValues?.();
  xrkTableRef.value?.initList?.();
};

/** 勾选/取消产品：勾选=加入勾选集合 + 激活；取消=移出勾选集合 + 清场景 + 清该产品 selectionIds */
const onToggleProduct = (productId: string) => {
  const checked = checkedMap.get(productId);
  if (checked) {
    // 取消勾选：移出集合 + 清该产品已勾选场景的 selectionIds（_id 前缀 = productId_）
    checkedMap.delete(productId);
    removeProductSelectionIds(productId);
    if (activeProductId.value === productId) {
      activeProductId.value = '';
      xrkTableRef.value?.clearSearchValues?.();
      xrkTableRef.value?.initList?.();
    }
    return;
  }
  // 勾选：以产品基础数据为基底（补 scenes 空数组，结构对齐 SceneManageProductItem）+ 空场景
  const product = allProducts.value.find(p => p.productId === productId);
  if (!product) return;
  checkedMap.set(productId, {
    ...JSON.parse(JSON.stringify(product)),
    scenes: []
  });
  if (activeProductId.value !== productId) {
    activeProductId.value = productId;
    // 清空 store 勾选（同 onSwitchProduct：表头「已选 N 项」按全局 selectionIds 计数）
    xrkTableRef.value?.clearSelectionRows?.();
    // 清空 store 勾选（同 onSwitchProduct：表头「已选 N 项」按全局 selectionIds 计数）
    xrkTableRef.value?.clearSelectionRows?.();
    xrkTableRef.value?.clearSearchValues?.();
    xrkTableRef.value?.initList?.();
  }
};

/** 清理某产品的场景勾选（selectionIds 前缀匹配） */
const removeProductSelectionIds = (productId: string) => {
  const prefix = `${productId}_`;
  const rows = xrkTableRef.value?.getSelectionRows?.() || [];
  rows.forEach(r => {
    if (r._id?.startsWith(prefix)) {
      xrkTableRef.value?.removeSelectionRow?.(r._id);
    }
  });
};

/** 场景勾选同步勾选集合：产品自动入集合（UI 勾选样式）+ scenes 维护（已选计数实时）；_id 前缀反推产品 */
const syncSceneChecked = (row: any, checked: boolean) => {
  const productId = String(row._id || '').split('_')[0];
  if (!productId) return;
  let product = checkedMap.get(productId);
  if (checked) {
    // 产品未勾选但勾选场景 → 自动带入勾选集合（左侧勾选样式同步）
    if (!product) {
      const base = allProducts.value.find(p => p.productId === productId);
      if (!base) return;
      product = {
        ...JSON.parse(JSON.stringify(base)),
        scenes: []
      };
      checkedMap.set(productId, product);
    }
    product.scenes = product.scenes || [];
    if (!product.scenes.some(s => s.sceneId === row.sceneId)) {
      product.scenes.push(JSON.parse(JSON.stringify(row)));
    }
  } else {
    if (!product) return;
    product.scenes = (product.scenes || []).filter(
      s => s.sceneId !== row.sceneId
    );
  }
};

/** 全选/清空（当前筛选条件下）：全选=遍历全部数据加入 selectionIds + 同步勾选集合；清空=移除当前产品全部场景勾选（不调接口） */
const onSelectAll = async (checked: boolean) => {
  if (!activeProductId.value) return;
  if (!checked) {
    // 清空：移除当前产品前缀的 selectionIds + 清勾选集合 scenes（selectionRows 更新自动刷新表格，不调接口）
    removeProductSelectionIds(activeProductId.value);
    const product = checkedMap.get(activeProductId.value);
    if (product) {
      product.scenes = [];
    }
    return;
  }
  const search =
    (xrkTableRef.value?.getSearchValue?.() as Record<string, any>) || {};
  // 当前激活产品三属性（匹配覆盖值，无值传 undefined 不序列化）
  const activeProd = allProducts.value.find(
    p => p.productId === activeProductId.value
  );
  sceneLoading.value = true;
  try {
    const allScenes: SceneManageSceneItem[] = [];
    let pageNum = 1;
    let total = 0;
    do {
      const res = await getSceneSceneList({
        productId: activeProductId.value,
        planId: props.planId || undefined,
        industryId: props.industryId || undefined,
        aspId: props.aspId || undefined,
        sceneName: search.sceneName || undefined,
        terminalChannelText: search.terminalChannelText || undefined,
        serviceObjectText: search.serviceObjectText || undefined,
        medicalRepTag: search.medicalRepTag || undefined,
        productCategory: activeProd?.productCategory || undefined,
        productAttribute: activeProd?.productAttribute || undefined,
        lifecycleStage: activeProd?.lifecycleStage || undefined,
        pageNum,
        pageSize: 100
      });
      const data = res?.data;
      allScenes.push(...(data?.scenePage?.list || []));
      total = data?.scenePage?.total || 0;
      pageNum += 1;
    } while (allScenes.length < total && pageNum <= 50);
    allScenes.forEach(scene => {
      const _id = scene._id || `${activeProductId.value}_${scene.sceneId}`;
      xrkTableRef.value?.addSelectionRow?.(_id, { ...scene, _id });
      // addSelectionRow 不触发 selectionAddAfter 钩子：手动同步勾选集合
      syncSceneChecked({ ...scene, _id }, true);
    });
    xrkTableRef.value?.initList?.();
  } catch (error) {
    console.error('全选场景失败:', error);
    XrkMessage.error('全选失败');
  } finally {
    sceneLoading.value = false;
  }
};

const onCancel = () => {
  props.remove();
};

/** 确认：从 XrkTable selectionRows 构造勾选集合（_id 前缀分产品，勾场景自动带产品）+ 手动勾选产品校验；校验失败阻止关闭 */
const onConfirm = () => {
  const rows = xrkTableRef.value?.getSelectionRows?.() || [];

  // 勾选产品集合：场景勾选（rows 按 _id 前缀分组自动带产品）+ 手动勾选（checkedMap，保留无场景的用于校验）
  const productMap = new Map<string, SceneManageProductItem>();
  rows.forEach((row: any) => {
    const productId = String(row._id || '').split('_')[0];
    if (!productId) return;
    let product = productMap.get(productId);
    if (!product) {
      // 产品信息：checkedMap（手动勾选）优先，否则用产品列表基础数据（勾场景自动带）
      const checked = checkedMap.get(productId);
      const base = allProducts.value.find(p => p.productId === productId);
      if (checked) {
        product = JSON.parse(JSON.stringify(checked));
      } else if (base) {
        product = {
          ...JSON.parse(JSON.stringify(base)),
          scenes: []
        };
      } else {
        return;
      }
      productMap.set(productId, product);
    }
    product.scenes = product.scenes || [];
    if (!product.scenes.some(s => s.sceneId === row.sceneId)) {
      product.scenes.push(JSON.parse(JSON.stringify(row)));
    }
  });
  // 手动勾选但未勾场景的产品也进入集合（校验「每个已选产品至少选择一个场景」）
  checkedMap.forEach((p, productId) => {
    if (!productMap.has(productId)) {
      productMap.set(productId, JSON.parse(JSON.stringify(p)));
    }
  });

  const checkedProducts = [...productMap.values()];
  if (checkedProducts.length === 0) {
    XrkMessage.warning('请先在左侧选择至少一个产品');
    return Promise.reject();
  }

  // 校验：每个已选产品至少选择一个场景
  const noSceneProduct = checkedProducts.find(
    p => (p.scenes || []).length === 0
  );
  if (noSceneProduct) {
    XrkMessage.warning('每个已选产品至少选择一个场景');
    return Promise.reject();
  }

  emit('confirm', checkedProducts);
  props.remove();
};

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    class: "scene-select-dialog",
    style: {"max-height":"98vh","width":"85%","height":"90vh"},
    "model-value": true,
    title: "选择场景",
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    "cancel-btn-config": { show: true, content: '取消' },
    "confirm-btn-config": { show: true, content: '确定' },
    "before-cancel": onCancel,
    "before-confirm": onConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("aside", _hoisted_2, [
          _createVNode(_unref(BaseAffix), {
            offset: affixOffset.value,
            class: "left-affix"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (isIndustry.value)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 0,
                      link: "",
                      type: "primary2",
                      onClick: onAddProduct
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 新增产品 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((productQuery).value = $event)),
                class: "product-search",
                placeholder: "搜索产品名称、类别或属性"
              }, null, 512), [
                [_vModelText, productQuery.value]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.productId,
                    class: _normalizeClass(["product-row", {
                active: activeProductId.value === product.productId,
                checked: checkedMap.has(product.productId)
              }]),
                    onClick: ($event: any) => (onSwitchProduct(product.productId))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: checkedMap.has(product.productId),
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      onChange: ($event: any) => (onToggleProduct(product.productId))
                    }, null, 40, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(product.productName), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString([
                      product.productCategory,
                      product.productAttribute,
                      product.productType == 2 ? '' : product.lifecycleStage
                    ]
                      .filter(Boolean)
                      .join(' / ')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (product.available === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 不可使用 "))
                        : _createCommentVNode("", true),
                      (getProductSceneCount(product.productId))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 已选 " + _toDisplayString(getProductSceneCount(product.productId)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_6))
                }), 128)),
                (filteredProducts.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 未找到匹配产品 "))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_xrk_loading, productLoading.value]
              ])
            ]),
            _: 1
          }, 8, ["offset"])
        ]),
        _createElementVNode("section", _hoisted_15, [
          (!activeProduct.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(activeProduct.value.productName), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createTextVNode(" 产品类别： "),
                  _createElementVNode("b", null, _toDisplayString(activeProduct.value.productCategory || '—'), 1),
                  _createTextVNode(" 产品属性： "),
                  _createElementVNode("b", null, _toDisplayString(activeProduct.value.productAttribute || '—'), 1),
                  (activeProduct.value.productType != 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 产品生命周期： "),
                        _createElementVNode("b", null, _toDisplayString(activeProduct.value.lifecycleStage || '—'), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_23
              ])),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_unref(XrkTable), {
              ref_key: "xrkTableRef",
              ref: xrkTableRef,
              getListAjax: getListAjax,
              searchConfig: searchConfig.value,
              tableConfig: tableConfig.value,
              paginationConfig: paginationConfig
            }, null, 8, ["searchConfig", "tableConfig"])
          ])), [
            [_directive_xrk_loading, sceneLoading.value]
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})